"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;
var solid_1 = require("@heroicons/react/24/solid");
var react_1 = __importStar(require("react"));
require("../../../index.css");
var Modal = /** @class */function (_super) {
  __extends(Modal, _super);
  function Modal() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.initialFocusRef = (0, react_1.createRef)();
    _this.renderModalWidth = function () {
      switch (_this.props.maxWidth) {
        case "lg":
          return "sm:max-w-lg";
        case "xl":
          return "sm:max-w-xl";
        case "2xl":
          return "sm:max-w-2xl";
        case "3xl":
          return "sm:max-w-3xl";
        default:
          return "sm:max-w-lg";
      }
    };
    return _this;
  }
  Modal.prototype.render = function () {
    var _a;
    var _b = this.props.lib,
      Dialog = _b.Dialog,
      Transition = _b.Transition;
    return react_1.default.createElement(Transition.Root, {
      show: this.props.open,
      as: react_1.Fragment
    }, react_1.default.createElement(Dialog, {
      as: "div",
      static: true,
      className: "fixed z-40 inset-0 overflow-y-auto",
      open: this.props.open,
      initialFocus: this.initialFocusRef,
      onClose: this.props.onClose ? this.props.onClose : function () {}
    }, (_a = this.props.notification) !== null && _a !== void 0 ? _a : null, react_1.default.createElement("div", {
      className: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0",
      ref: this.initialFocusRef
    }, react_1.default.createElement(Transition.Child, {
      as: react_1.Fragment,
      enter: "ease-out duration-300",
      enterFrom: "opacity-0",
      enterTo: "opacity-100",
      leave: "ease-in duration-200",
      leaveFrom: "opacity-100",
      leaveTo: "opacity-0"
    }, react_1.default.createElement(Dialog.Overlay, {
      className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
    })), react_1.default.createElement("span", {
      className: "hidden sm:inline-block sm:align-middle sm:h-screen",
      "aria-hidden": "true"
    }, "\u200B"), react_1.default.createElement(Transition.Child, {
      as: react_1.Fragment,
      enter: "ease-out duration-300",
      enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
      enterTo: "opacity-100 translate-y-0 sm:scale-100",
      leave: "ease-in duration-200",
      leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
      leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    }, react_1.default.createElement("div", {
      className: "inline-block w-full align-bottom bg-white rounded-lg px-4 pt-5 pb-10 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:p-6 " + this.renderModalWidth()
    }, react_1.default.createElement("div", null, this.props.title && react_1.default.createElement("div", {
      className: "flex flex-row border-b border-gray-200 pb-4 w-full"
    }, react_1.default.createElement(Dialog.Title, {
      as: "h3",
      className: "text-lg leading-6 font-medium text-gray-900"
    }, this.props.title), react_1.default.createElement("div", {
      className: "flex-grow"
    }), this.props.onClose && react_1.default.createElement(solid_1.XMarkIcon, {
      className: "h-5 w-5 cursor-pointer text-primary-600",
      onClick: this.props.onClose
    })), react_1.default.createElement("div", {
      className: "mt-2"
    }, this.props.renderContent && this.props.renderContent())))))));
  };
  return Modal;
}(react_1.Component);
exports.Modal = Modal;